import React, { useState,useEffect } from 'react';
const challengesData = [
  {
    id: 1,
    title: "Limited Access to Finance",
    code: "ACCESS TO FINANCE",
    description: "Many farmers lack access to affordable credit and insurance.",
    solution: "Solution: Develop inclusive agricultural financing, microloans, and mobile banking services tailored to smallholders."
  },
  {
    id: 2,
    title: "Poor Infrastructure",
    code: "COMPLIANCE",
    description: "Inadequate roads, storage, and market facilities hinder distribution and increase post-harvest losses.",
    solution: "Solution: Invest in rural infrastructure, including roads, warehouses, and market access points."
  },
  {
    id: 3,
    title: "Low Access to Technology and Inputs",
    code: "MARKET ACCESS",
    description: "Limited availability of quality seeds, fertilizers, and modern tools.",
    solution: "Solution: Encourage public-private partnerships to improve input supply chains and subsidize access for small-scale farmers."
  },
  {
    id: 6,
    title: "Climate Change & Unpredictable Weather",
    code: "CASH FLOW",
    description: "Droughts, floods, and changing weather patterns disrupt farming cycles.",
    solution: "Solution: Promote climate-smart agriculture, drought-resistant seeds, and improved weather forecasting tools."
  },
  {
    id: 5,
    title: "Market Access and Price Volatility",
    code: "TECHNOLOGY",
    description: "Farmers struggle to connect with profitable markets and face unstable prices.",
    solution: "Solution: Support farmer cooperatives, develop value chains, and use digital platforms to connect farmers with buyers."
  },
 
  {
    id: 7,
    title: "Youth Disinterest in Agriculture",
    code: "MENTORSHIP",
    description: "Agriculture is seen as unprofitable and labor-intensive.",
    solution: "Solution: Promote agribusiness, use of technology, and access to land and finance for young entrepreneurs."
  },
  {
    id: 8,
    title: "Pests and Diseases",
    code: "INSTABILITY",
    description: "Crop and livestock pests can wipe out harvests and income.",
    solution: "Solution: Increase research on pest control, and provide early warning systems and access to effective pesticides or biological controls."
  },
  {
    id: 9,
    title: "Land Tenure Insecurity",
    code: "INNOVATION",
    description: "Many farmers work without formal land rights, discouraging long-term investment.",
    solution: "Solution: Implement land reforms and promote secure, documented land ownership."
  },
  {
    id: 10,
    title: "Lack of Skills and Technical Know-How",
    code: "INFORMATION ACCESS",
    description: "Limits smallholder farmers' productivity and income potential by preventing them from adopting modern, efficient farming practices.",
    solution: "Solution: Targeted training, access to extension services, and digital tools tailored to their needs."
  },
  {
    id: 11,
    title: "Crime and Insecurity",
    code: "SECURITY",
    description: "Disrupt smallholder farmers' activities by threatening their safety, crops, and livestock, leading to reduced productivity and investment.",
    solution: "Solution: Strengthened rural security, community policing, and support systems to protect livelihoods."
  },
  {
    id: 12,
    title: "Lack of Information",
    code: "INFORMATION ACCESS",
    description: "Prevents smallholder farmers from making informed decisions about markets, weather, and best practices, leading to lower yields and income.",
    solution: "Solution: Improved access to timely, relevant agricultural information through mobile platforms and extension services."
  },
  {
    id: 13,
    title: "Others",
    code: "OTHERS",
    description: "",
    solution: ""
  }
];
const IndustrySection = ({
  selected = [],
  setSelected,
  vision = "",
  setVision,
  onSave
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
// In IndustrySection.jsx

const handleSelect = (id) => {
  if (selected.includes(id)) {
    setSelected(selected.filter(item => item !== id));
  } else {
    setSelected([...selected, id]);
  }
};


// In IndustrySection.jsx
const handleSave = () => {
  if (onSave) {
    const selectedChallenges = challengesData
      .filter(challenge => selected.includes(challenge.id))
      .map(challenge => ({
        id: challenge.id,
        title: challenge.title,
        description: challenge.description,
        solution: challenge.solution,
        code: challenge.code
      }));
      
    onSave({
      selectedChallenges,
      vision
    });
  }
};



useEffect(() => {
  handleSave();
}, [selected, vision]);

  useEffect(() => {
    // Log and save data whenever it changes
    console.log("Industry Activity Survey:", {
      selectedChallenges: selected,
      vision
    });
    onSave({
      selectedChallenges: selected,
      vision
    });
  }, [selected, vision, onSave]);

  return (
    <div className='md:mt-8 mt-3'>

      {/* Vision input */}
      <div className='md:mt-6'>
      <p className="md:text-[32px] text-[8px] italic font-medium text-center md:mb-4">
      Please select your personal, group, or cooperative experience, along with your special interests and vision for your involvement in the industry
        </p>
        <h1 className='md:text-[32px] font-bold text-[6px]'>
        Please describe your vision and objectives for your enterprise activities.
        </h1>
      </div>
      <div className='md:mt-6 mt-1'>
        <input
          type='input'
          value={vision}
          onChange={e => setVision(e.target.value)}
          className='bg-[#F5F5F5] rounded-[5px] w-full md:h-[141px] pl-2 h-[60px] md:pb-20 placeholder:text-black text-black md:pl-6 text-[6px] md:text-[24px] font-normal'
          placeholder='type..'
        />
      </div>
      
      {/* Challenges multiple select */}
      <div className='md:mt-6 mt-3'>
        <h1 className='md:text-[32px] text-[8px] font-bold'>
        What difficulties do you encounter in reaching your vision and goals?
        </h1>
      </div>
      
      {/* Buttons grid */}
      <div className="grid grid-cols-2 md:gap-1 gap-1 md:mt-5 mt-2">
        {challengesData.map((challenge, i) => {
          const isActive = selected.includes(challenge.id);
          const isHovered = hoveredItem === i;
          
          return (
            <div
              key={challenge.id} // Using the unique ID now
              className="relative"
              onMouseEnter={() => setHoveredItem(i)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <button
                onClick={() => handleSelect(challenge.id)}
                className={`
                  flex flex-col justify-between
                  w-full text-left
                  bg-[#F5F5F5]
                  border border-[#F5F5F5] rounded-[5px]
                  md:px-4 px-2
                  overflow-hidden
                  transition-all duration-300 ease-in-out
                  ${isHovered ? 'md:h-[220px] h-[80px]' : 'md:h-[80px] h-[20px]'}
                `}
              >
                <div className="flex md:justify-center justify-between mt-1 items-center w-full md:mt-3">
                  <span className="font-medium text-[4px] md:text-[20px] md:w-full leading-[1.10]">
                    {challenge.title}
                  </span>
                  <span
                    className={`
                      md:w-14 md:h-14 w-3 h-3 rounded-full flex-shrink-0
                      ${isActive 
                        ? 'bg-[#2E453D] md:border-[6px] border-[3px] border-white'
                        : 'md:border-[6px] border-[3px] border-white bg-[#D9D9D9]'}
                    `}
                  />
                </div>
                
                {isHovered && (
                  <div className="mt-2 transition-opacity duration-200">
                    <p className="text-[6px] md:text-[18px] font-normal ">
                      {challenge.description}
                    </p>
                    <p className="text-[6px] md:text-[18px] font-normal">
                      {challenge.solution}
                    </p>
                  </div>
                )}
              </button>
              
              {/* This creates the "growing from bottom" effect */}
              <div className={`
                absolute bottom-0 left-0 right-0 
                bg-[#F5F5F5] rounded-b-[5px]
                transition-all duration-300 ease-in-out
                ${isHovered ? 'h-full' : 'h-0'}
                pointer-events-none
                z-[-1]
              `}/>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default IndustrySection;